import styled from 'styled-components';
import IconChevronDown from './IconChevronDown';
var IconChevronUp = /*#__PURE__*/styled(IconChevronDown).withConfig({
  displayName: "IconChevronUp",
  componentId: "c11n-8-107-0__sc-17fqy61-0"
})(["transform:rotate(180deg);"]);
export default IconChevronUp;